export const jsonProduction =
{
    "mtServiceUrl": "https://devicegw.sentineldna.com",
    "GoogleApiWrapper": "AIzaSyBpirc3QTYyZ4M8bpx0QfWTyvPtoYELXtM"
};
  